import { css } from '@linaria/core';

export const styledButton = css`
	--button-color-primary: transparent;
	--button-color-secondary: var(--color-grey-85-solid);
	--button-color-additional: transparent;
	border-width: 2px;
	border-style: solid;
	--additional-padding-x: 0px;

	&:hover:not(.disabled, :focus, .selected),
	&.checkbox-button:hover:not(.disabled, .selected) {
		--button-color-primary: var(--color-white-xs);
		--button-color-secondary: var(--color-grey-95-solid);
	}

	&:focus:not(:active, .selected, .loading, .checkbox-button) {
		--button-color-additional: var(--color-white-solid);
		--button-color-secondary: var(--color-white-solid);
	}

	&:active:not(.selected) {
		--button-color-primary: var(--color-white-m);
		--button-color-secondary: var(--color-grey-95-solid);
	}

	&.disabled:not(.selected) {
		--button-color-secondary: var(--color-grey-52-solid);
		--button-color-primary: var(--color-grey-6-solid);
	}

	&.selected {
		--button-color-primary: var(--color-white-s);
		--button-color-secondary: var(--color-grey-85-solid);
	}

	&.selected.icon {
		--button-color-additional: var(--color-grey-85-solid);
		border-width: 1px;
		--additional-padding-x: 1px;
	}
`;
